import React from 'react';
import styled from 'styled-components';
import { SvgIcon } from '@make-software/cspr-ui';

export const StyledInfoSvgIcon = styled(SvgIcon)(({ theme }) => ({
  path: {
    fill: theme.styleguideColors.contentTertiary,
  },
}));

export const InfoSvgIcon = React.forwardRef((props, ref) => (
  <StyledInfoSvgIcon ref={ref} role="img" alt={'Information icon'} {...props} />
));
